import { gql } from '@apollo/client';
/**
 * @const ExportSaleItemVariantsMutation
 * @since 1.0.0
 */
export const ExportSaleItemVariantsMutation = gql `
  mutation ExportSaleItemsMutation($input: ExportSaleItemVariantsInput!) {
    exportSaleItemVariants(input: $input)
  }
`;
